import * as React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Box, useMediaQuery } from "@mui/material";
import FlexBetween from "./FlexBetween";
import { FlexColCenter } from "./FlexBox/FlexBox";

export default function DocumentUploadPill({ pillTitle, pillDescription, buttonText, buttonColor, buttonAction, buttonAction2, buttonText2, imageView, imageDescription, imageColour, showLink=true}) {
	
	const isNonMobileScreen = useMediaQuery("(min-width:600px)");
	
	return (
		<Box sx={{
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			marginY: "10px"
		}}>
			<Box>
				<Typography sx={{ fontWeight: 600 }} variant="h4" component="div">{pillTitle}</Typography>
				{isNonMobileScreen && <Typography sx={{ fontWeight: 300 }} variant="h6" component="div">{pillDescription}</Typography>}
			</Box>
			<FlexBetween>
				
				{imageView &&
					<FlexColCenter>
						{showLink && <a href={imageView} target="_blank"  >Click to Download Document</a>}
						<Typography sx={{ fontWeight: "bold" }} component="div" color={imageColour}>{imageDescription}</Typography>
					</FlexColCenter>
				}
				{buttonText && 
					<Button color={buttonColor} sx={{ marginX:"4px" }}  variant="outlined" onClick={buttonAction}>{buttonText}</Button>
				}
				{buttonText2 && 
					<Button color={buttonColor} sx={{ marginX:"4px" }} variant="outlined" onClick={buttonAction2}>{buttonText2}</Button>
				}
				
			</FlexBetween>
			
		</Box>
	);
}
